import React, { useMemo, useState } from 'react';
import { toCssDeclarationName } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/css-declarations';
import { NumberUnitInput } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/number-unit-input';
import { InlineInputCardWrapper } from '@/features/editor/widgets/shared/ai-editing-layout/inputs/shared/shared';
import {
  hasImportant,
  stripImportant,
  addImportantIfNeeded,
} from '@/features/editor/widgets/shared/ai-editing-layout/inputs/parsers';

export interface CssNumericUnitInputProps {
  name: string;
  initialValue?: string;
  onChange?: (name: string, value: string) => void;
}

export function CssNumericUnitInput({
  name,
  initialValue,
  onChange,
}: CssNumericUnitInputProps) {
  const displayName = useMemo(() => toCssDeclarationName(name), [name]);
  const [error, setError] = React.useState<string>(``);

  // Track if initial value had !important
  const [hadImportant] = useState(() => hasImportant(initialValue || ``));
  const cleanInitialValue = useMemo(
    () => stripImportant(initialValue || ``),
    [initialValue],
  );

  const onValueChanged = (value: string) => {
    if (onChange) {
      const outputValue = addImportantIfNeeded(value, hadImportant);
      onChange(name, outputValue);
    }
  };

  return (
    <InlineInputCardWrapper className={error ? `error` : ``}>
      <span>{displayName}</span>
      <NumberUnitInput
        initialValue={cleanInitialValue}
        onChange={onValueChanged}
        onError={setError}
      />
    </InlineInputCardWrapper>
  );
}
